/* eslint-disable @typescript-eslint/no-use-before-define */
import { h } from "@stencil/core";
/**
 * @deprecated Use the `ch-combo-box-render` with `suggest = true`
 */
export const renderSuggestLists = (suggestData) => {
    if (suggestData?.suggestLists.length) {
        const randomNumber = Math.random();
        const result = suggestData.suggestLists.map((list) => {
            return (h("ch-suggest-list", { label: list.label, key: randomNumber }, list.items.map((item) => {
                return renderSuggestListsItem(item);
            })));
        });
        return result;
    }
    return null;
};
const renderSuggestListsItem = (suggestItem) => {
    return (h("ch-suggest-list-item", { value: suggestItem.value }, [suggestItem.description || suggestItem.value]));
};
